import { z } from "zod";
import { DIMENSION_LABELS, SERVICE_SLUGS } from "./exterior-services";

const UK_POSTCODE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
export const PHOTO_PATH = /^pending\/[0-9a-f-]{36}\/[0-9a-f-]{36}\.(jpg|jpeg|png|webp|heic|heif)$/;
export const PROPERTY_PHOTO_PATH = /^users\/[0-9a-f-]{36}\/[0-9a-f-]{36}\.(jpg|jpeg|png|webp)$/;
export const MAX_PHOTOS = 8;

const dimensionKeys = Object.keys(DIMENSION_LABELS) as [string, ...string[]];

export function normalisePostcode(value: string) {
  const compact = value.toUpperCase().replace(/\s+/g, "");
  return compact.length > 3 ? `${compact.slice(0, -3)} ${compact.slice(-3)}` : compact;
}

export const quoteRequestSchema = z.object({
  services: z.array(z.enum(SERVICE_SLUGS as [string, ...string[]])).min(1, "Choose at least one service").max(SERVICE_SLUGS.length),
  propertyType: z.enum(["house", "flat", "commercial", "other"]),
  addressLine: z.string().trim().max(200).optional().default(""),
  town: z.string().trim().max(100).optional().default(""),
  postcode: z.string().trim().regex(UK_POSTCODE, "Enter a valid UK postcode").transform(normalisePostcode),
  dimensions: z.record(z.enum(dimensionKeys), z.number().min(0).max(100000)).optional().default({}),
  notSureOfSize: z.boolean().optional().default(false),
  description: z.string().trim().max(2000).optional().default(""),
  photoPaths: z.array(z.string().refine(path => PHOTO_PATH.test(path) || PROPERTY_PHOTO_PATH.test(path), "Invalid photo path")).max(MAX_PHOTOS).optional().default([]),
  fullName: z.string().trim().min(2, "Enter your name").max(100),
  phone: z.string().trim().regex(/^[+\d][\d\s()-]{8,19}$/, "Enter a valid phone number"),
  email: z.string().trim().email("Enter a valid email").max(255),
  preferredContact: z.enum(["phone", "email", "text"]),
  consent: z.literal(true, { errorMap: () => ({ message: "Please agree to be contacted" }) }),
  website: z.string().max(0).optional().default(""), // honeypot: must stay empty
  accessToken: z.string().max(4000).optional(),
});
export type QuoteRequestInput = z.input<typeof quoteRequestSchema>;
